import { CopyError } from '../copy/text.js';
import { viewerStrings } from '../copy/strings.js';
import { baseQuery } from '@cdr-clarity/query-service';
import type { GroupReference, QueryField, QueryResult } from '@cdr-clarity/contracts';
import { recordPage, type RecordPage } from './record-page.js';
import { hiddenQueryFields } from './query-references.js';

export type DrillDown = (reference: GroupReference) => Promise<QueryResult>;

/** Keep the original report and ancestor keys intact when paging its source memberships. */
export async function groupRecords(
  drillDown: DrillDown,
  reference: GroupReference,
  visible: readonly QueryField[],
  cursors: readonly string[] | null,
): Promise<RecordPage> {
  const hidden = hiddenQueryFields(reference.query, new Set(visible.map((field) => field.id)));
  if (hidden.length)
    throw new CopyError(viewerStrings.webStateGroupRecords.theReportUsesFieldsThatAreNow);
  const fields = visible
    .filter((field) => field.collections.includes(reference.query.scope.collection))
    .map((field) => field.id);
  const definition = { ...baseQuery(reference.query.scope), page: { size: 100 } };
  return recordPage(
    (query) =>
      drillDown({
        ...reference,
        query: {
          ...reference.query,
          projections: query.projections,
          page: query.page,
          // Global visibility was checked above. Each projection batch stays within
          // the field limit without counting the report's unchanged dependencies twice.
          visibleFields: undefined,
        },
      }),
    definition,
    fields,
    cursors,
  );
}
